<template>
  <div class="purchase-form-overlay" @click.self="closeForm">
    <div class="purchase-form-container">
      <div class="purchase-form-header">
        <h2>产品购买</h2>
        <button class="close-button" @click="closeForm">&times;</button>
      </div>
      
      <div class="purchase-form-content">
        <!-- 产品信息 -->
        <div class="product-info" v-if="product">
          <h3>{{ product.Title }}</h3>
          <div class="product-details">
            <p><strong>型号:</strong> {{ product.model }}</p>
            <p><strong>封装:</strong> {{ product.Package }}</p>
            <p v-if="product.price"><strong>价格:</strong> {{ product.price }}</p>
          </div>
        </div>
        
        <!-- 购买表单 -->
        <form @submit.prevent="submitForm" class="form">
          <!-- 联系信息 -->
          <div class="form-section">
            <h4>联系信息</h4>
            
            <div class="form-group">
              <label for="company">公司名称 <span class="required">*</span></label>
              <input 
                type="text" 
                id="company" 
                v-model="formData.company" 
                required
                :disabled="isSubmitting"
              >
            </div>
            
            <div class="form-group">
              <label for="name">联系人 <span class="required">*</span></label>
              <input 
                type="text" 
                id="name" 
                v-model="formData.name" 
                required
                :disabled="isSubmitting"
              >
            </div>
            
            <div class="form-group">
              <label for="phone">联系电话 <span class="required">*</span></label>
              <input 
                type="tel" 
                id="phone" 
                v-model="formData.phone" 
                required
                :disabled="isSubmitting"
              >
            </div>
            
            <div class="form-group">
              <label for="email">电子邮箱</label>
              <input 
                type="email" 
                id="email" 
                v-model="formData.email"
                :disabled="isSubmitting"
              >
            </div>
          </div>
          
          <!-- 订单信息 -->
          <div class="form-section">
            <h4>订单信息</h4>
            
            <div class="form-group">
              <label for="quantity">购买数量 <span class="required">*</span></label>
              <input 
                type="number" 
                id="quantity" 
                v-model.number="formData.quantity" 
                min="1" 
                required
                :disabled="isSubmitting"
              >
            </div>
            
            <div class="form-group">
              <label for="requirements">特殊要求</label>
              <textarea 
                id="requirements" 
                v-model="formData.requirements"
                rows="3"
                :disabled="isSubmitting"
              ></textarea>
            </div>
          </div>
          
          <!-- 提交状态 -->
          <div v-if="submitStatus" :class="['submit-status', submitStatus.type]">
            {{ submitStatus.message }}
          </div>
          
          <!-- 表单按钮 -->
          <div class="form-actions">
            <button 
              type="button" 
              class="cancel-button" 
              @click="closeForm"
              :disabled="isSubmitting"
            >
              取消
            </button>
            <button 
              type="submit" 
              class="submit-button" 
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? '提交中...' : '提交订单' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import emailService from '../api/emailService';
export default {
  name: 'PurchaseForm',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        company: '',
        name: '',
        phone: '',
        email: '',
        quantity: 1,
        requirements: ''
      },
      isSubmitting: false,
      submitStatus: null
    };
  },
  created() {
    // 将产品信息添加到表单数据中
    if (this.product) {
      this.formData.productId = this.product.id;
      this.formData.productName = this.product.Title;
      this.formData.productModel = this.product.model;
    }
  },
  methods: {
    closeForm() {
      this.$emit('close');
    },
    async submitForm() {
      this.isSubmitting = true;
      this.submitStatus = null;
      
      try {
        // 准备邮件数据
        const emailData = {
          subject: `产品购买请求: ${this.formData.productName}`,
          body: `
            客户信息:
            公司: ${this.formData.company}
            联系人: ${this.formData.name}
            电话: ${this.formData.phone}
            邮箱: ${this.formData.email || '未提供'}
          
            产品信息:
            产品名称: ${this.formData.productName}
            产品型号: ${this.formData.productModel}
            产品ID: ${this.formData.productId}
            购买数量: ${this.formData.quantity}
          
            特殊要求:
            ${this.formData.requirements || '无特殊要求'}
          `
        };
        
        // 发送邮件请求
        const response = await emailService.sendPurchaseEmail(emailData);
        
        if (response.data && response.data.success) {
          // 成功响应
          this.submitStatus = {
            type: 'success',
            message: '订单提交成功！我们的销售人员将尽快与您联系。'
          };
          
          // 3秒后关闭表单
          setTimeout(() => {
            this.closeForm();
          }, 3000);
        } else {
          throw new Error(response.data?.message || '订单提交失败');
        }
        
      } catch (error) {
        console.error('购买请求失败:', error);
        this.submitStatus = {
          type: 'error',
          message: error.message || '订单提交失败，请稍后再试或直接联系我们。'
        };
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
.purchase-form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.purchase-form-container {
  background-color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.purchase-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.purchase-form-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.purchase-form-content {
  padding: 20px;
}

.product-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.product-info h3 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
}

.product-details {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.product-details p {
  margin: 5px 0;
}

.form-section {
  margin-bottom: 25px;
}

.form-section h4 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
  color: #333;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #555;
}

.required {
  color: #e53935;
}

input, textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

input:focus, textarea:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

input:disabled, textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-button, .submit-button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cancel-button {
  background-color: #f5f5f5;
  color: #333;
}

.cancel-button:hover {
  background-color: #e0e0e0;
}

.submit-button {
  background-color: #4a90e2;
  color: white;
}

.submit-button:hover {
  background-color: #3a7bc8;
}

.cancel-button:disabled, .submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-status {
  padding: 10px 15px;
  margin: 15px 0;
  border-radius: 4px;
}

.submit-status.success {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
}

.submit-status.error {
  background-color: #ffebee;
  color: #c62828;
  border: 1px solid #ef9a9a;
}

@media (max-width: 600px) {
  .purchase-form-container {
    width: 95%;
    max-height: 85vh;
  }
  
  .product-details {
    grid-template-columns: 1fr;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .cancel-button, .submit-button {
    width: 100%;
  }
}
</style>